<template>
<div>
    <HeaderTeam header="ตั้งค่า" :img_header="header_image" link_back="team" />
    <MenuTeamSettingList />
    <HoursWorkedList />
</div>
</template>

<script>
import HeaderImage from '@/assets/settings.png'
import HeaderTeam from '@/components/menuadmin/team/teamheader/HeaderTeam.vue'
import MenuTeamSettingList from '@/components/menuadmin/team/teamsetting/MenuTeamSettingList.vue'
import HoursWorkedList from '@/components/menuadmin/team/teamsetting/HoursWorkedList.vue'
export default {
    name: 'hoursWorked',
    components: {
        HeaderTeam,
        MenuTeamSettingList,
        HoursWorkedList,
    },
    data() {
        return {
            header_image: HeaderImage
        }
    }
}
</script>
